module.exports = __webpack_public_path__ + "files/8bbb19efe3fd27e1c1998de0efc3a88d.svg";